"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glCore = require("@capture/gl-core");

var _PatternTypes = require("../PatternTypes");

class PatternCropOverlayFilter extends _glCore.GLFilter {
  constructor() {
    const fsSource = `
        precision highp float;
        varying highp vec2 v_uv;
        
        uniform bool isEnabled;
        uniform highp vec2 point1;
        uniform highp vec2 point2;
        uniform highp vec2 point3;

        uniform sampler2D t_tex;
        
        vec2 line(vec2 point1, vec2 point2) {
            float slope = (point2.y - point1.y) / (point2.x - point1.x + 0.00001);
            float intercept = point1.y - (slope * point1.x);
            return vec2(slope, intercept);
        }
        
        bool isAround(vec2 line, vec2 uv) {
            float overShoot = uv.y - (line.x * uv.x + line.y);
            return overShoot > -0.004000 && overShoot <= 0.004000;
        }

        bool isAbove(vec2 line, vec2 uv) {
            return uv.y - (line.x * uv.x + line.y) >= 0.0;
        }
        
        bool isInnerOutline(vec2 line1, vec2 line2, vec2 line3, vec2 uv) {
            return (isAround(line1, uv) && isAbove(line2, uv) && !isAbove(line3, uv)) ||
	            (isAbove(line1, uv) && isAround(line2, uv) && !isAbove(line3, uv)) ||
	            (isAbove(line1, uv) && isAbove(line2, uv) && isAround(line3, uv));
        }
        
        bool isOuterOutline(vec2 uv) {
            return (uv.x <= 0.004) || (uv.x >= (1.0 - 0.004)) || (uv.y <= 0.004) || (uv.y >= (1.0 - 0.004));
        }
                        
        void main() {
            vec2 uv = v_uv;
	        uv.y = 1.0 - uv.y;
	        vec4 color = texture2D(t_tex, uv);

            if (isEnabled) {
                vec2 line1 = line(point2, point1);
                vec2 line2 = line(point3, point2);
                vec2 line3 = line(point1, point3);
                
                if (isAbove(line1, uv) && !isAbove(line2, uv) && isAbove(line3, uv)) {
                    gl_FragColor = color;
                } else {
                    gl_FragColor = color * 0.5 + vec4(0.0, 0.0, 0.0, 0.5) * 0.5;
                }
	        } else {
	            gl_FragColor = color;
	        }
        }
        `;
    super(fsSource);
    this.isEnabled = true;
    this.patternType = _PatternTypes.PatternTypes.SixFoldReflectedFilter;
  }

  initUniformLocations(gl, program) {
    let uniforms = super.initUniformLocations(gl, program);
    uniforms.isEnabled = gl.getUniformLocation(program, 'isEnabled');
    uniforms.uPoint1 = gl.getUniformLocation(program, 'point1');
    uniforms.uPoint2 = gl.getUniformLocation(program, 'point2');
    uniforms.uPoint3 = gl.getUniformLocation(program, 'point3');
    return uniforms;
  }

  willDraw(gl, uniformLocations, attributeLocations, flip) {
    super.willDraw(gl, uniformLocations, attributeLocations, flip);
    let points = (0, _PatternTypes.getPatternOutlinePoints)(this.patternType);

    if (points.length === 3) {
      gl.uniform1f(uniformLocations.isEnabled, true && this.isEnabled);
      gl.uniform2fv(uniformLocations.uPoint1, points[0]);
      gl.uniform2fv(uniformLocations.uPoint2, points[1]);
      gl.uniform2fv(uniformLocations.uPoint3, points[2]);
    } else {
      gl.uniform1f(uniformLocations.isEnabled, false && this.isEnabled);
    }
  }

}

exports.default = PatternCropOverlayFilter;